import React from 'react'
import ReactPaginate from 'react-paginate'
import {useIntl} from 'react-intl'
import UsersListRow from './UsersListRow'

const UsersListTable: React.FC<any> = ({
  isLoading,
  usersList,
  currentPage,
  pageCount,
  handlePageClick,
}) => {
  const intl = useIntl()

  const columns = [
    {field: 'Id', label: 'GENERAL.LABEL.ID', sortable: false},
    {field: 'Email', label: 'AUTH.INPUT.EMAIL', sortable: false},
    {field: 'DcsSiteId', label: 'GENERAL.LABEL.DCSSITEID', sortable: false},
    {field: 'DcsUserId', label: 'GENERAL.LABEL.DCSUSERID', sortable: false},
    {field: 'AvatarUrl', label: 'GENERAL.LABEL.AVATARURL', sortable: false},
    {field: 'DisplayName', label: 'GENERAL.LABEL.DISPLAYNAME', sortable: false},
    {field: 'CustomerId', label: 'GENERAL.LABEL.CUSTOMERID', sortable: false},
    {field: 'Company', label: 'GENERAL.LABEL.COMPANY', sortable: false},
    {field: 'Role', label: 'GENERAL.LABEL.ROLE', sortable: false},
    {field: 'Status', label: 'GENERAL.LABEL.STATUS', sortable: false},
    {field: 'Action', label: 'DEVICE.ACTIONS', sortable: false},
  ]

  return (
    <div className='card-body py-3'>
      {/* begin::Table container */}

      <div className='table-responsive max-height-75vh'>
        {/* begin::Table */}
        <table
          className={`table align-middle table-row-bordered fs-6 gy-5 dataTable no-footer compact
            }`}
        >
          {/* begin::Table head */}
          <thead className='sticky-header'>
            <tr className='text-muted'>
              {columns.map((column: any, i: any) => {
                return (
                  // <th key={i} style={{ width: column.label == 'Actions' ? listView == 'compact' ? '72px' : '358px' : 'auto' }}>
                  <th key={i}>
                    <div className={column.sortable ? 'sortable cursor-pointer' : ''}>
                      {intl.formatMessage({id: column.label})}
                    </div>
                  </th>
                )
              })}
            </tr>
          </thead>
          {/* end::Table head */}
          {/* begin::Table body */}
          <tbody className='text-gray-600'>
            {usersList.length > 0 ? (
              <>
                {usersList &&
                  usersList.map((usersList: any, i: number) => {
                    return (
                      <React.Fragment key={i}>
                        <UsersListRow userlist={usersList} />
                      </React.Fragment>
                    )
                  })}
              </>
            ) : (
              <tr>
                <td colSpan={9}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    {intl.formatMessage({id: 'TOOLTIP.NO_MATCHING_RECORDS_FOUND'})}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
          {/* end::Table body */}
        </table>

        {/* end::Table */}
      </div>

      <div className='row pt-3'>
        <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
        <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
          {usersList.length > 0 && (
            <div id='kt_table_users_paginate'>
              {!isLoading && (
                <ReactPaginate
                  className='pagination'
                  breakLabel='...'
                  nextLabel={<>Next &raquo;</>}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  pageClassName='page-item'
                  previousLinkClassName='page-link'
                  previousClassName='page-item'
                  nextClassName='page-item'
                  nextLinkClassName='page-link'
                  previousLabel={<>&laquo; Previous</>}
                  activeClassName='active'
                  pageLinkClassName='page-link'
                  forcePage={currentPage}
                />
              )}
            </div>
          )}
        </div>
      </div>
      {/* end::Table container */}
    </div>
  )
}

export default UsersListTable
